import type { EditorConfig } from "./types";
import {
  Heading,
  Paragraph,
  Quote,
  Verse,
  Image,
  Gallery,
  Divider,
  Callout,
  Video,
  Embed,
  List,
  Code,
  Spacer,
  Button,
  Hero,
  TwoColumn,
  Stat,
  Cta,
  Table,
  Accordion,
  Columns,
  Audio,
  Pdf,
  Footnotes,
  Math,
  Row,
  Chant,
  Sankalpa,
  registerRowSerialisers,
} from "./blocks";

/**
 * Block palette for the Document editor. Documents share the same generic
 * editor as articles — the same registry of blocks, the same drag-and-drop
 * canvas — but they're metadata + introductory prose, *not* the full text.
 * The actual content of a mantra/sūkta lives in attachments. So this palette
 * leans into:
 *
 *   - quick "what this is" framing (heading, lead paragraph, callout)
 *   - mood-setting media (cover hero, a single image, a short verse pull)
 *   - context (footnotes for sources, a small reading list)
 *
 * The palette is intentionally identical to the article palette so a future
 * editor block we add lands in both surfaces at once. Templates differ — see
 * `components/document/templates.ts`.
 */
const documentBlockTypes = [
  Heading,
  Paragraph,
  List,
  Quote,
  Verse,
  Callout,
  Footnotes,
  Image,
  Gallery,
  Video,
  Audio,
  Pdf,
  Chant,
  Sankalpa,
  Embed,
  Code,
  Math,
  Hero,
  TwoColumn,
  Columns,
  Row,
  Table,
  Accordion,
  Stat,
  Cta,
  Button,
  Divider,
  Spacer,
];

registerRowSerialisers(documentBlockTypes);

export const documentEditorConfig: EditorConfig = {
  blockTypes: documentBlockTypes,
  paletteOrder: [
    "heading",
    "paragraph",
    "callout",
    "verse",
    "quote",
    "list",
    "footnotes",
    "image",
    "gallery",
    "video",
    "audio",
    "pdf",
    "chant",
    "embed",
    "math",
    "hero",
    "two-column",
    "columns",
    "table",
    "accordion",
    "stat",
    "cta",
    "button",
    "code",
    "divider",
    "spacer",
  ],
};
